"use client";

import { AppSidebar } from "@/components/app-sidebar";
import { DataStreamProvider } from "@/components/data-stream-provider";
import { SidebarInset, SidebarProvider } from "@/components/ui/sidebar";
import { AuthProvider, useAuth } from "../auth/hooks";

/**
 * Layout for authenticated chat routes.
 * Wraps children with AuthProvider that requires authentication.
 */
export default function ChatLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <AuthProvider requireAuth={true}>
      <ChatLayoutContent>{children}</ChatLayoutContent>
    </AuthProvider>
  );
}

function ChatLayoutContent({ children }: { children: React.ReactNode }) {
  const {user, status} = useAuth();

  return (
    <DataStreamProvider>
      <SidebarProvider defaultOpen={true}>
        <AppSidebar user={user?.user} isLoading={status === "loading"} />
        <SidebarInset className="chat-pattern-background">
          <div className="relative h-dvh w-full bg-background/80 dark:bg-background/92">
            {children}
          </div>
        </SidebarInset>
      </SidebarProvider>
    </DataStreamProvider>
  );
}
